.grid-view {
  --grid-max-height: 500px;
  --grid-min-height: 180px;
}

.header-buttons-outside-grid {
  margin-top: calc(3 * var(--spacer));
  position: relative;
}

.header-buttons-outside-grid, .header-buttons {
  gz-button, gz-split-button {
    margin-right: 16px;
  }
}

gz-tooltip {
  &.disabled {
    pointer-events: none;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

:host(.removeGridPadding) {
  ::part(gridToolbar) {
    display: none;
  }
}

:host(.addPaddingGridTop) {
  .grid-view {
    padding-top: 16px;
  }
}

:host(.dataTableColumnWidth600) {
  gz-data-table {
    --column-max-width: 600px;
  }
}

:host(.hideButtonsOutsideGrid) {
  .header-buttons-outside-grid {
    display: none;
  }
}

.form-field-info-text {
  padding-top: calc(var(--spacer));
}

gz-checkbox {
  width: auto;
  color: var(--main-titles-inputs-600);
}
